import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppInput from '../../../../common/AppInput';
import { Grid } from '@material-ui/core';
import { schema } from './validation/schema';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  inputContainer: {
    '& > div > div': {
      width: '100%',
    },
  },
  form: {
    width: '100%',
  },
}));

const Password = ({ ...props }) => {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [matchError, setMatchError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [matchSuccess, setMatchSuccess] = useState(false);

  const { onClick, modifiable, onFocus, internalValidation } = props;

  const handleClick = (event) => {
    onClick(event.target.value);
  };
  const handleClickInitialForm = (event) => {
    setPassword('');
    setConfirmationPassword('');
    setMatchSuccess(false);
    setPasswordSuccess(false);
    onClick(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleConfirmationPasswordChange = (event) => {
    setConfirmationPassword(event.target.value);
  };
  const handleValidation = () => {
    if ('error' in schema.validate({ password: password })) {
      setPasswordError(true);
      setErrorMessage(schema.validate({ password: password }).error.message);
      setPasswordSuccess(false);
    } else {
      setPasswordError(false);
      setErrorMessage('');
      setPasswordSuccess(true);
    }
  };
  const matchPasswords = () => {
    if (
      password !== confirmationPassword ||
      password === '' ||
      confirmationPassword === ''
    ) {
      setMatchError(true);
      setMatchSuccess(false);
    } else {
      setMatchError(false);
      setMatchSuccess(true);
    }
  };

  useEffect(() => {
    onFocus({ password: password, confirmationPassword: confirmationPassword });
  }, [password, confirmationPassword]);

  useEffect(() => {
    if (internalValidation) {
      handleValidation();
      matchPasswords();
    }
  }, [internalValidation]);

  return (
    <Grid container spacing={2} className={classes.inputContainer}>
      {!modifiable && (
        <Grid item md={6} xs={12}>
          <AppInput
            name="password"
            type="password"
            value="*****"
            label="Contraseña"
            inputAdornment=""
            onClick={handleClickInitialForm}
          />
        </Grid>
      )}
      {modifiable && (
        <form className={classes.form}>
          <Grid container spacing={2} className={classes.inputContainer}>
            <Grid item md={6} xs={12}>
              <AppInput
                name="password"
                type="password"
                autoComplete="new-password"
                value={password}
                label="Nueva contraseña"
                inputAdornment=""
                error={passwordError}
                errorMessage={errorMessage}
                success={passwordSuccess}
                onChange={handlePasswordChange}
                onBlur={handleValidation}
                onClick={handleClick}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppInput
                name="password"
                type="password"
                autoComplete="new-password"
                value={confirmationPassword}
                label="Confirmar contraseña"
                inputAdornment=""
                error={matchError}
                errorMessage={'Contraseñas no coinciden'}
                success={matchSuccess}
                onChange={handleConfirmationPasswordChange}
                onBlur={matchPasswords}
                onClick={handleClick}
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Grid>
  );
};

Password.propTypes = {
  modifiable: PropTypes.bool,
  internalValidation: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
};

export default Password;
